import { firebase } from '@/api/firebase'

const lastTracked = {}
const DEDUPE_MS = 2500

function todayKey() {
  return new Date().toISOString().slice(0, 10)
}

function shouldTrack(page) {
  const now = Date.now()
  if (lastTracked[page] && now - lastTracked[page] < DEDUPE_MS) return false
  lastTracked[page] = now
  return true
}

function isTrackableRoute(path) {
  if (path.startsWith('/admin')) return false
  return true
}

function pageFromRoute(route) {
  if (route.path === '/') {
    const section = route.hash?.replace('#', '') || 'home'
    return section
  }
  if (route.path === '/signin') return 'signin'
  return route.path.replace(/^\//, '') || 'home'
}

export async function trackPageView(route) {
  if (!route || !isTrackableRoute(route.path)) return

  const page = pageFromRoute(route)
  if (!shouldTrack(page)) return

  const path = route.fullPath || route.path
  await firebase.trackPageVisit(page, path, {
    referrer: typeof document !== 'undefined' ? document.referrer : '',
  })
}

export function initPageAnalytics(router) {
  router.afterEach((to) => {
    trackPageView(to)
  })
}

export async function fetchAnalytics() {
  const data = (await firebase.getValue('analytics')) || {}
  return {
    total: data.total || 0,
    pages: data.pages || {},
    daily: data.daily || {},
    recent: normalizeRecent(data.recent),
  }
}

function normalizeRecent(recent) {
  if (!recent || typeof recent !== 'object') return []

  return Object.entries(recent)
    .map(([id, entry]) => ({
      id,
      page: entry?.page || 'unknown',
      path: entry?.path || '',
      at: entry?.at || 0,
      referrer: entry?.referrer || '',
    }))
    .sort((a, b) => b.at - a.at)
}

export function sumDailyRange(daily, days = 7) {
  const result = []
  const cursor = new Date()

  for (let i = days - 1; i >= 0; i -= 1) {
    const date = new Date(cursor)
    date.setDate(cursor.getDate() - i)
    const key = date.toISOString().slice(0, 10)
    result.push({ date: key, count: daily[key] || 0 })
  }

  return result
}

export function sumCounts(values) {
  return Object.values(values || {}).reduce((sum, value) => sum + (Number(value) || 0), 0)
}

export function visitsToday(daily) {
  return daily[todayKey()] || 0
}
